export enum CuttingType {
  MILLING_AND_TURNING = "MILLING_AND_TURNING",
  SHEET_METAL = "SHEET_METAL",
  SHEET_METAL_STP = "SHEET_METAL_STP",
  SHEET_METAL_DXF = "SHEET_METAL_DXF",
  SHEET_METAL_DWG = "SHEET_METAL_DWG",
  SHEET_METAL_CONFIGURE = "SHEET_METAL_CONFIGURE"
}
